import { NgModule } from '@angular/core';
import { RestrictPatternDirective } from './restrict-pattern.directive';

@NgModule({
  declarations: [RestrictPatternDirective],
  exports: [RestrictPatternDirective],
})
export class RestrictPatternDirectiveModule {}
